import { render, staticRenderFns } from "./DcSection.vue?vue&type=template&id=0e1a5cfa&scoped=true&"
import script from "./DcSection.vue?vue&type=script&lang=js&"
export * from "./DcSection.vue?vue&type=script&lang=js&"
import style0 from "./DcSection.vue?vue&type=style&index=0&id=0e1a5cfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1a5cfa",
  null
  
)

export default component.exports